import FileServiceModel   from '@/models/FileServiceModel';
import doc                from '@widesk-core/decorators/doc';
import model              from '@widesk-core/decorators/model';

@model.urnResource('file_status')
@doc.path('/stonecode_file_file_statuses/{?id}')
export default class FileStatusModel extends FileServiceModel {
	public _tsFilters = {};

	public _tsSorts = {};

	@doc.string declare label: string;
	
}
